/*
 * Back / Forward shows a cached copy of the page (browser HTTP cache or back-forward cache), so the cart drawer and
 * the cart icon show the cart as it was when that page first loaded — e.g. "Your cart is empty" after the shopper
 * added a seat on the next page and pressed Back, while Shopify still holds the seat (seen in Clarity 22/10: 2 of 10
 * shoppers who added to cart, one left, one added again). When a page comes back this way, the real cart is read from
 * Shopify and the drawer + icon are repainted in place (the drawer stays closed); the /cart page simply reloads.
 * Other cart scripts (fee line, Switch box, gifts) watch the drawer DOM and re-read the cart by themselves after it.
 * Loaded `defer` from every layout that renders the cart drawer.
 */
(function () {
  'use strict';
  if (window.SeatFitCartRefreshOnBack) return;
  var base = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var running = false;

  function cameBack() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav) return nav.type === 'back_forward';
      return !!(performance.navigation && performance.navigation.type === 2);
    } catch (e) { return false; }
  }
  function drawer() { return document.querySelector('cart-drawer'); }
  function sections(d) {
    try {
      if (d && typeof d.getSectionsToRender === 'function') {
        var list = d.getSectionsToRender();
        if (list && list.length) return list;
      }
    } catch (e) { /* default below */ }
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }
  function innerOf(d, html, selector) {
    if (d && typeof d.getSectionInnerHTML === 'function') return d.getSectionInnerHTML(html, selector);
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : '';
  }

  function refresh() {
    if (running) return;
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    running = true;
    var d = drawer();
    var list = sections(d);
    var ids = list.map(function (s) { return s.section || s.id; }).filter(Boolean);
    Promise.all([
      fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }),
      fetch(base + '?sections=' + encodeURIComponent(ids.join(',')), { cache: 'no-store' }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var cart = res[0] || {}, html = res[1] || {};
      list.forEach(function (s) {
        var id = s.section || s.id;
        var node = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        if (node && html[id]) node.innerHTML = innerOf(d, html[id], s.selector);
      });
      var empty = !cart.item_count;
      if (d) {
        d.classList.toggle('is-empty', empty);
        var inner = d.querySelector('.drawer__inner');
        if (inner && !empty) inner.classList.remove('is-empty');
      }
    }).catch(function (e) {
      console.warn('[SeatFit] cart refresh on back', e);
    }).then(function () { running = false; });
  }

  window.SeatFitCartRefreshOnBack = { refresh: refresh };
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  if (cameBack()) refresh();
})();
